/**
 * The onboarding container that renders the onboarding wizard with the given steps
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import OnBoardingWizard from 'components/OnBoardingWizard/OnBoardingWizard';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { writeUserSettings } from 'redux/modules/session';
import { CAP_KEY, ONBOARDING_KEY } from 'config';
import { ROOT } from 'routes';
import _ from 'lodash';
import Steps from './Steps';
import AppContext from 'containers/App/AppContext';

class OnBoarding extends Component {

	constructor(props) {
		super();
		this.complete = this.complete.bind(this);
		this.stepFulfilled = this.stepFulfilled.bind(this);
		this.stepSkipped = this.stepSkipped.bind(this);
		this.state = {
			// The completed flag indicates if the onboarding has finished.
			// We store its value in state and don't update when a new props
			// are received. This is because the last step gets fulfilled
			// automatically when it's shown, but we need to keep this step
			// on screen until the user reloads a page. If the completed flag
			// is set to true we redirect to the root.
			completed: _.get(props.settings, 'completed', false)
		};
	}

	render() {
		const { completed } = this.state;
		const { fulfilled, skipped } = this.props.settings;

		if (completed) {
			return <Redirect to={ROOT} />;
		}

		return (
			<AppContext.Consumer>
				{context => (
					<OnBoardingWizard
						steps={Steps}
						fulfilledSteps={fulfilled}
						skippedSteps={skipped}
						onCompleted={this.complete}
						onStepFulfilled={this.stepFulfilled}
						onStepSkipped={this.stepSkipped}
						onStepActive={context.scrollContentToTop}
					/>
				)}
			</AppContext.Consumer>
		);
	}

	/**
	 * Completes the onboarding
	 */
	complete() {
		this.syncSettings({
			completed: true
		});
	}

	/**
	 * Fulfills a step by adding current step to the fulfilled array and syncing with the server
	 * @param oId {String} The step identifier
	 */
	stepFulfilled(oId) {
		const { settings = {} } = this.props;
		const { fulfilled = [] } = settings;

		if (fulfilled.indexOf(oId) === -1) {
			fulfilled.push(oId);
			this.syncSettings({ fulfilled });
		}
	}

	/**
	 * Skips a step by adding current step to the skipped array and syncing with the server
	 * @param oId {String} The step identifier
	 */
	stepSkipped(oId) {
		const { settings = {} } = this.props;
		const { skipped = [] } = settings;

		if (skipped.indexOf(oId) === -1) {
			skipped.push(oId);
			this.syncSettings({ skipped });
		}
	}

	/**
	 * Sync settings with the server by sending request to it
	 * @param settings {Object} Settings object
	 */
	syncSettings(settings) {
		this.props.writeUserSettings({
			[ONBOARDING_KEY]: { ...settings }
		});
	}

}

OnBoarding.defaultProps = {
	settings: {}
};

OnBoarding.propTypes = {
	settings: PropTypes.object, // settings from session.user
	writeUserSettings: PropTypes.func // action creator from session module
};

const mapStateToProps = state => {
	return {
		settings: _.get(state.session, `user.settings.${CAP_KEY}.${ONBOARDING_KEY}`)
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	writeUserSettings
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(OnBoarding);


// WEBPACK FOOTER //
// ./src/containers/OnBoarding/OnBoarding.js